module.exports = __webpack_public_path__ + "media/Video 141b.d033668f.mp4";